<lib-loading-shimmer [showLoading]="loading()" class="icon-cell">
  <mat-icon
    [svgIcon]="'more-horizontal'"
    [floatUi]="dropdownContent"
    #floatUiDirective="floatUi"
    [showTrigger]="NgxFloatUiTriggers.click"
    [placement]="NgxFloatUiPlacements.BOTTOMSTART"
    [hideOnClickOutside]="true"
    [positionFixed]="true"
    [preventOverflow]="true"
    class="options-table-cell-clickable-icon">
  </mat-icon>
</lib-loading-shimmer>
<float-ui-content #dropdownContent>
  <div class="py-2">
    @for (option of options(); track $index) {
      <div class="dropdown-option" (click)="optionClicked(option); $event.stopPropagation()">
        {{ option.title }}
      </div>
    }
  </div>
</float-ui-content>
